<template>
  <a-spin :spinning="loading">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="profile"/>
     Otros Formularios
    </span>
        <a-row :gutter="[16,16]">
          <a-form>
            <a-col :span="24">
              <a-card v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_FORMULARIOS', 'NO') === 'SI'">
                <div>
                  <a-alert
                    :message="$getConfigValue('MENSAJE1_ALERTA_FORMULARIOS')"
                    :description="$getConfigValue('MENSAJE2_ALERTA_FORMULARIOS')"
                    type="info"
                    show-icon
                  />
                  <br>
                </div>
              </a-card>
              <a-card title="">
                <a slot="extra" @click="consultarFormularios">Actualizar</a>
                <a-list
                  item-layout="horizontal"
                  :data-source="formularios"
                >
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <a slot="actions" v-if="item.status && !$userIsInrol('Query')" @click="diligenciarFormulario(item)">Diligenciar</a>
                    <a-list-item-meta>
                      <a slot="title" v-if="item.status">{{ item.name }}</a>
                      <a-progress slot="description" v-if="item.status && mostrarPorcentajeFormulariosBiodata" :percent="parseInt(item.porcentaje)"
                                  status="active"/>
                    </a-list-item-meta>

                    <div>
                    </div>
                  </a-list-item>
                </a-list>
              </a-card>
            </a-col>
          </a-form>
        </a-row>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['persona'],
    data () {
      return {
        mostrarPorcentajeFormulariosBiodata: this.$getConfigValue('MOSTRAR_PROGRESO_FORMULARIOS_BIODATA') !== 'NO',
        loading: false,
        formularios: []
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.consultarFormularios()
    },
    methods: {
      consultarFormularios () {
        this.loading = true
        this.httpClient.getInstance().get('biodata/consultar_otros_formularios', {
          params: {
            id_person: this.persona
          }
        })
          .then(response => {
            this.formularios = response.data
          })
          .catch(error => {
            Mensajes.error('Error', 'No fue posible cargar los formularios disponibles.')
          })
          .then(() => {
            this.loading = false
          })
      },
      diligenciarFormulario (formulario) {
        let fnAbrirVentana = (idFormFillout) => {
          let routeData = this.$router.resolve({
            name: 'FormFillout',
            query: {fillOutId: idFormFillout, formulario_desde_biodata: true}
          })
          window.open(routeData.href, '_blank')
        }

        if (JsUtils.isEmpty(formulario.id_forms_fillout)) {
          this.httpClient.getInstance().post('biodata/registrar_otro_formulario', {
            id_form: formulario.id,
            id_person: this.persona
          }).then(response => {
            fnAbrirVentana(response.data.id_forms_fillout)
          })
            .catch(error => {
              Mensajes.error('Error', 'No fue posible regisrar el formulario.')
            })
        } else {
          fnAbrirVentana(formulario.id_forms_fillout)
        }
      },
      redirect () {
        this.$router.push({name: 'Dashboard'})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataOtrosFormularios.vue